import { render } from "./QuoteProducts.vue?vue&type=template&id=72a5b824&scoped=true"
import script from "./QuoteProducts.vue?vue&type=script&lang=js"
export * from "./QuoteProducts.vue?vue&type=script&lang=js"

import "./QuoteProducts.vue?vue&type=style&index=0&id=72a5b824&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72a5b824"]])

export default __exports__